import { BasePage } from '@/components/ui/base-page'

export function CommoditiesPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add CommoditiesPage specific content here */}
    </BasePage>
  )
}